var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import $ from 'jquery';
import { Component, Vue } from 'vue-property-decorator';
import '../../config';
import run from '../../config/runModule';
var MODULE_NAME = 'appBlocksContactUsForm';
var _a = PageData('contact-us-form'), MessagePlaceholder = _a.MessagePlaceholder, ObjectId = _a.ObjectId, ObjectName = _a.ObjectName, ObjectH1 = _a.ObjectH1, Template = _a.Template;
var SITE_KEY = '6LcLu_0UAAAAAHGTjssph3oNx8dbaBv75leXL7uM';
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '';
        _this.email = '';
        _this.phone = '';
        _this.message = '';
        _this.attemptSubmit = false;
        _this.success = false;
        _this.error = false;
        _this.loading = false;
        return _this;
    }
    Object.defineProperty(App.prototype, "emptyName", {
        // computed
        get: function () {
            return this.name === '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "emptyPhone", {
        get: function () {
            return this.phone === '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "wrongEmail", {
        get: function () {
            return !this.validEmail(this.email);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "formValid", {
        get: function () {
            return !this.emptyName && !this.emptyPhone && !this.wrongEmail;
        },
        enumerable: false,
        configurable: true
    });
    // methods
    App.prototype.onSubmit = function () {
        var self = this;
        grecaptcha.ready(function () {
            grecaptcha.execute(SITE_KEY, { action: 'submit' }).then(function (token) {
                $.ajax({
                    type: 'POST',
                    url: '/storefrontapi/recaptcha',
                    contentType: 'application/json',
                    data: JSON.stringify({ token: token }),
                }).done(function (data) {
                    if (data.success && data.score >= 0.5) {
                        self.submit();
                        return;
                    }
                });
            });
        });
    };
    App.prototype.submit = function () {
        var _this = this;
        var _a = window.AppMainFilter, locationTooltips = (_a === void 0 ? {} : _a).locationTooltips;
        this.attemptSubmit = true;
        if (this.formValid) {
            this.loading = true;
            var csrfToken = $('input[name="__RequestVerificationToken"]').val();
            var formData = {
                UserEmail: this.email,
                UserName: this.name,
                UserPhone: this.phone,
                UserMessage: this.message,
                FromUrl: location.href,
                ObjectId: ObjectId,
                ObjectName: ObjectName,
                ObjectH1: ObjectH1,
                Template: Template,
                Location: (locationTooltips && locationTooltips.selectedItem) ? locationTooltips.selectedItem.fullName : null,
                UtmSource: this.getUtm('utm_source'),
                UtmMedium: this.getUtm('utm_medium'),
                UtmContent: this.getUtm('utm_content'),
                UtmCampaign: this.getUtm('utm_campaign'),
                __RequestVerificationToken: csrfToken,
            };
            if (this.message === '') {
                formData.UserMessage = MessagePlaceholder;
            }
            var eventLabel_1 = (Template === 'product' ? 'Product' : 'Category') + ' Page';
            if (this.$el.id === 'appBlocksContactUsFormInGallery') {
                eventLabel_1 += ' Images';
            }
            $.ajax({
                type: 'POST',
                url: '/storefrontapi/forms',
                contentType: 'application/x-www-form-urlencoded',
                data: formData,
            }).done(function (_a) {
                var success = _a.success;
                _this[success ? 'success' : 'error'] = true;
                gtag('event', 'Submission ' + success ? 'Success' : 'Fail', {
                    event_category: 'Request Form',
                    event_label: eventLabel_1,
                });
            }).catch(function () {
                _this.error = true;
                gtag('event', 'Submission Fail', {
                    event_category: 'Request Form',
                    event_label: eventLabel_1,
                });
            });
            // tslint:disable-next-line: object-literal-key-quotes
            window.dataLayer.push({ 'event': 'userFormSubscribe' });
        }
    };
    App.prototype.validEmail = function (email) {
        // tslint:disable-next-line: max-line-length
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };
    App.prototype.getUtm = function (param) {
        var regex = new RegExp("&?" + param + "=([^&]*)?", 'gm');
        var m = regex.exec(location.search);
        return m ? m[1] : undefined;
    };
    App = __decorate([
        Component({
            name: MODULE_NAME,
        })
    ], App);
    return App;
}(Vue));
run(MODULE_NAME, App);



//////////////////
// WEBPACK FOOTER
// ./vue/modules/blocks.contact-us-form/index.ts
// module id = 26Vp
// module chunks = 7